import { formatPersianNumber } from "@/lib/format/persian";

// Mirrors the backend's 402 payload when a store's commission debt is over the limit.
export const COMMISSION_DEBT_ERROR_CODE = "commission_debt_limit";

export const IBAN_PATTERN = /^IR\d{24}$/;

export const PAY_DEBT_ROLE_NAMES = ["store_owner", "finance_manager"] as const;

/** 0.04 → "۴٪" */
export function formatCommissionRate(rate: number): string {
  return `${formatPersianNumber(Math.round(rate * 1000) / 10)}٪`;
}

/** Decimal columns come back from the API as strings ("50000.00"). */
export function toAmount(value: number | string | null | undefined): number {
  const parsed = Number(value ?? 0);
  return Number.isFinite(parsed) ? parsed : 0;
}

export function normalizeIban(value: string): string {
  return value.replace(/\s/g, "").toUpperCase();
}
